var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlusSquare = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40px",
  height: "40px",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  ref: ref,
  "aria-labelledby": titleId
}, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, "Plus_icon@2x") : title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ui-elements",
  transform: "translate(-1003.000000, -710.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Plus_icon",
  transform: "translate(1003.000000, 710.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-3-Copy-12",
  stroke: "#3E5660",
  x: 0.5,
  y: 0.5,
  width: 39,
  height: 39
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-13-Copy-3",
  fill: "#3E5660",
  x: 19,
  y: 14,
  width: 1.5,
  height: 12
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle-13-Copy-4",
  fill: "#3E5660",
  transform: "translate(20.000000, 19.750000) rotate(-270.000000) translate(-20.000000, -19.750000) ",
  x: 19.25,
  y: 13.75,
  width: 1.5,
  height: 12
})))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlusSquare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plus-square.9c5572abef57fefaec74193ee44913aa.svg";